module.exports = __webpack_public_path__ + "static/media/ping-pong.0513b773.gif";